import baseUrl from "../config/baseUrl";

const deleteUser = async ({ token, id }) => {
  const formData = new FormData();
  formData.append("id", id);

  try {
    const response = await fetch(`${baseUrl}/apireact/delete_user`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default deleteUser;
